/**
 * 业务对象ID
 */
// export const id = 'id';
export const labelText = "系统自动填充";
/**
 * 摘要
 */
export const name = "name";
/**
 * 单据号
 */
export const sequence_no = "sequenceNo";
/**
 * 单据状态
 */
export const sequence_status = "sequenceStatus";
/**
 * 创建人
 */
export const creater = "creater";
/**
 * 创建人部门
 */
export const created_dept_id = "createdDeptId";
/**
 * 创建时间
 */
export const created_time = "createdTime";
/**
 * 所有人
 */
export const owner = "owner";
/**
 * 所有人部门
 */
export const owner_dept_Id = "ownerDeptId";
/**
 * 修改人
 */
export const modifier = "modifier";
/**
 * 修改时间
 */
export const modified_time = "modifiedTime";
